/// <reference path="../../src/types.d.ts" />

export const defaultFilterableOptions: CMxCommonApp.FilterableOption = {
  dateFilter: undefined,
  filters: []
};
